<h2 mat-dialog-title>{{ 'fail_request.title' | translate }}</h2>
<p>{{ 'fail_request.descr' | translate }}</p>